/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS GPS lost detection api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LssConsumerMetricsSchema
 */
export interface LssConsumerMetricsSchema {
    /**
     * Accumulated delay in seconds of messages read from AIS stream by the LSS consumer
     * @type {any}
     * @memberof LssConsumerMetricsSchema
     */
    lssConsumerMsgAccumulatedDelayTotal: any | null;
    /**
     * Total number of messages read from AIS stream by the LSS consumer
     * @type {any}
     * @memberof LssConsumerMetricsSchema
     */
    lssConsumerMsgReadFromStreamTotal: any | null;
    /**
     * Total number of messages written to internal queue by the LSS consumer
     * @type {any}
     * @memberof LssConsumerMetricsSchema
     */
    lssConsumerMsgInToQueueTotal: any | null;
    /**
     * Total number of messages read from internal queue by the LSS consumer
     * @type {any}
     * @memberof LssConsumerMetricsSchema
     */
    lssConsumerMsgOutOfQueueTotal: any | null;
    /**
     * Total number of invalid messages received by the LSS consumer
     * @type {any}
     * @memberof LssConsumerMetricsSchema
     */
    lssConsumerInvalidMsgFromQueueTotal: any | null;
    /**
     * Number of messages in queue in the LSS consumer
     * @type {any}
     * @memberof LssConsumerMetricsSchema
     */
    lssConsumerMsgInQueue: any | null;
    /**
     * Total number of delayed messages processed by the LSS consumer
     * @type {any}
     * @memberof LssConsumerMetricsSchema
     */
    lssConsumerDelayedMsgTotal: any | null;
    /**
     * The process cpu usage in percentage
     * @type {any}
     * @memberof LssConsumerMetricsSchema
     */
    lssConsumerProcessCpuPercentage: any | null;
    /**
     * Resident memory size in MBytes
     * @type {any}
     * @memberof LssConsumerMetricsSchema
     */
    lssConsumerProcessResidentMemory: any | null;
    /**
     * Open file descriptors
     * @type {any}
     * @memberof LssConsumerMetricsSchema
     */
    lssConsumerProcessOpenFds: any | null;
}

/**
 * Check if a given object implements the LssConsumerMetricsSchema interface.
 */
export function instanceOfLssConsumerMetricsSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lssConsumerMsgAccumulatedDelayTotal" in value;
    isInstance = isInstance && "lssConsumerMsgReadFromStreamTotal" in value;
    isInstance = isInstance && "lssConsumerMsgInToQueueTotal" in value;
    isInstance = isInstance && "lssConsumerMsgOutOfQueueTotal" in value;
    isInstance = isInstance && "lssConsumerInvalidMsgFromQueueTotal" in value;
    isInstance = isInstance && "lssConsumerMsgInQueue" in value;
    isInstance = isInstance && "lssConsumerDelayedMsgTotal" in value;
    isInstance = isInstance && "lssConsumerProcessCpuPercentage" in value;
    isInstance = isInstance && "lssConsumerProcessResidentMemory" in value;
    isInstance = isInstance && "lssConsumerProcessOpenFds" in value;

    return isInstance;
}

export function LssConsumerMetricsSchemaFromJSON(json: any): LssConsumerMetricsSchema {
    return LssConsumerMetricsSchemaFromJSONTyped(json, false);
}

export function LssConsumerMetricsSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): LssConsumerMetricsSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lssConsumerMsgAccumulatedDelayTotal': json['lss_consumer_msg_accumulated_delay_total'],
        'lssConsumerMsgReadFromStreamTotal': json['lss_consumer_msg_read_from_stream_total'],
        'lssConsumerMsgInToQueueTotal': json['lss_consumer_msg_in_to_queue_total'],
        'lssConsumerMsgOutOfQueueTotal': json['lss_consumer_msg_out_of_queue_total'],
        'lssConsumerInvalidMsgFromQueueTotal': json['lss_consumer_invalid_msg_from_queue_total'],
        'lssConsumerMsgInQueue': json['lss_consumer_msg_in_queue'],
        'lssConsumerDelayedMsgTotal': json['lss_consumer_delayed_msg_total'],
        'lssConsumerProcessCpuPercentage': json['lss_consumer_process_cpu_percentage'],
        'lssConsumerProcessResidentMemory': json['lss_consumer_process_resident_memory'],
        'lssConsumerProcessOpenFds': json['lss_consumer_process_open_fds'],
    };
}

export function LssConsumerMetricsSchemaToJSON(value?: LssConsumerMetricsSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lss_consumer_msg_accumulated_delay_total': value.lssConsumerMsgAccumulatedDelayTotal,
        'lss_consumer_msg_read_from_stream_total': value.lssConsumerMsgReadFromStreamTotal,
        'lss_consumer_msg_in_to_queue_total': value.lssConsumerMsgInToQueueTotal,
        'lss_consumer_msg_out_of_queue_total': value.lssConsumerMsgOutOfQueueTotal,
        'lss_consumer_invalid_msg_from_queue_total': value.lssConsumerInvalidMsgFromQueueTotal,
        'lss_consumer_msg_in_queue': value.lssConsumerMsgInQueue,
        'lss_consumer_delayed_msg_total': value.lssConsumerDelayedMsgTotal,
        'lss_consumer_process_cpu_percentage': value.lssConsumerProcessCpuPercentage,
        'lss_consumer_process_resident_memory': value.lssConsumerProcessResidentMemory,
        'lss_consumer_process_open_fds': value.lssConsumerProcessOpenFds,
    };
}

